import $ from 'jquery';
import Scroll from '../Scroll/_Scroll';

let ins;

class State {
  constructor() {
    console.log('[class State constructor]');
    this.$body = $('body');
    this.pageSekaiSen = $('.page-sekai-sen');
    this.classNameStateTop = 'state-top';
    this.classNameStateAncBottom = 'state-anc-bottom';
    this.classNameStateSekaisenTobira = 'state-sekaisen-tobira';
    this.classNameStateSekaisen = 'state-sekaisen';
    // this.classNamePageSekaiSenHide = 'page-sekai-sen--hide';
    this.classNamePageSekaiSenOpen = 'page-sekai-sen--open';
    this.status = ''; //bottom-anc or top
  }

  reset() {
    // console.log('reset');
    this.$body.removeClass(this.classNameStateAncBottom);
    this.$body.removeClass(this.classNameStateSekaisenTobira);
    this.$body.removeClass(this.classNameStateSekaisen);
    this.$body.removeClass(this.classNameStateTop);
    // this.pageSekaiSen.addClass(this.classNamePageSekaiSenHide);
    this.pageSekaiSen.removeClass(this.classNamePageSekaiSenOpen);
    $('.page-sekai-sen-container').show();
  }

  /*
    init：ページロード時
    top：ページトップ
    bottom-anc：ページ下部
    state-sekaisen-tobira：世界線 扉 表示
    sekaisen：世界線表示

   */
  goTo(type) {
    this.reset();
    this.status = type;
    console.log('ページ表示タイプ：' + this.status);

    if (type == 'top') {
      Scroll.ins.reflesh();
      this.$body.addClass(this.classNameStateTop);
    } else if (type == 'init') {
      this.$body.addClass(this.classNameStateTop);
    } else if (type == 'bottom-anc') {
      this.$body.addClass(this.classNameStateAncBottom);
      // this.pageSekaiSen.removeClass(this.classNamePageSekaiSenHide);
      this.pageSekaiSen.addClass(this.classNamePageSekaiSenOpen);
      $('.page-sekai-sen-container').hide();
    } else if (type == 'sekaisen-tobira') {
      this.$body.addClass(this.classNameStateSekaisenTobira);
    } else if (type == 'sekaisen') {
      this.$body.addClass(this.classNameStateSekaisen);
      $(window).scrollTop(0);
    }
  }
}

(() => {
  ins = new State();
})();

export default { ins };
